import { FC } from "react";
import styles from "./search.module.scss";
import { ReactComponent as SearchIcon } from "./assets/search.svg";
import { ReactComponent as ClearIcon } from "./assets/close.svg";
import { Tooltip } from "../tooltip/Tooltip";
import { IconButton } from "../iconButton/IconButton";

type Props = {
  handler: (arg: string) => void;
  value: string;
};

export const Search: FC<Props> = ({ handler, value }) => {
  const inputHandler = (arg: string) => {
    handler(arg);
  };
  return (
    <div className={styles.search}>
      <SearchIcon className={styles.searchIcon} />
      <div className={styles.box}>
        <input
          className={styles.input}
          value={value}
          onChange={(e) => inputHandler(e.target.value)}
          placeholder="Введите параметры поиска"
        />
      </div>
      <Tooltip label="Очистить">
        <IconButton onClick={() => inputHandler("")}>
          <ClearIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
